<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h1 class="h2">SMART Goals</h1>
    <!-- It won't show if there is no assessment data -->
    <button id = "create-goalsPage"  class="btn-blue-royal" mat-raised-button routerLink="/create-goals" color="primary">
      Create Goals
    </button>
</div>
<div class="row">
    <div class="col-sm-12 col-md-4 col-lg-4">
        <mat-card class="blue-light reslt-cards">
            <mat-card-title>Goals Accomplished</mat-card-title>
        </mat-card>
    </div>
    <div class="col-sm-12 col-lg-8 col-lg-8">
        <div class="table-responsive">
            <table class="table table-striped table-responsive-sm table-responsive-md table-responsive-lg">
                <thead>
                    <tr>
                        <th class="text-center" scope="col">Goal name</th>
                        <th scope="col">Progress</th>
                        <th scope="col">Due Date</th>
                        <th scope="col">Status</th>
                        <th scope="col">Edit</th>
                        <th scope="col">Delete</th>
                        <th scope="col">Complete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let goal of goalList let i = index">
                        <td>{{goal.specific}}</td>
                        <td>incomplete</td>
                        <td>{{goal.timeBound}}</td>
                        <td>incomplete</td>
                        <td>incomplete</td>
                        <td>incomplete</td>
                        <td>incomplete</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
